import axios from 'axios';
import { CONFIGURATIONS } from '../api';

export default {
    namespaced: true,
    state: {
        space_permissions: null,
        free_signup: true,
    },
    mutations: {
        set_space_permissions(state, permissions) {
            state.space_permissions = permissions;
        },
        set_signup(state, free_signup) {
            state.free_signup = free_signup;
        },
    },
    actions: {
        get({ commit }) {
            axios.get(CONFIGURATIONS).then((response) => {
                commit('set_space_permissions', response.data.SPACE_PERMISSIONS);
                commit('set_signup', response.data.FREE_SIGNUP);
            });
        },
    },
};
